import { useContext, useState } from 'react';
import { INVOICE_TYPE_SUPPLIER, WccDto } from '@sr/dto';
import Delete from '@mui/icons-material/Delete';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import { IconButton, Paper, Stack, Tooltip } from '@mui/material';
import { formatDate } from 'utils/date-format-helpers';
import { useSnack } from 'shared/ui/snack';
import PriceSpan from 'shared/ui/price-span';
import { WccSupplierInvoiceDialog } from './wcc-dialog/wcc-dialog-invoice-supplier';
import { FormData } from 'entities/wcc/wcc-dialog/wcc-dialog-invoice-supplier';
import { useInvoiceSupplierWcc } from 'features/invoice/invoice-wcc/invoice-wcc.hook';
import { Link } from 'shared/ui/link-base';
import useConfirmDialog from 'hooks/confirm-dialog.hook';
import { WccButton } from './wcc-button';

type Props = {
  initialWcc?: WccDto | null;
  invoiceId: number;
};

export function WccSupplierInvoiceButton({ initialWcc, invoiceId }: Props) {
  const { showSuccess, showError } = useSnack();
  const [wccDialogOpen, setWccDialogOpen] = useState(false);
  const { dataWcc, createInvoiceSupplierWcc, error, isLoading, reload: wccReload } = useInvoiceSupplierWcc(invoiceId);

  let total = 0;
  dataWcc.map((x) => (total += x.amount));

  const handleWccInvoice = async (data: FormData) => {
    return createInvoiceSupplierWcc({ invoiceId, date: new Date(data.date), wccNumber: data.wccNumber, amount: Number(data.amount) })
      .then(() => {
        showSuccess('Документ закрытия успешно создан');
        setWccDialogOpen(false);
        wccReload();
      })
      .catch((e) => showError(`Ошибка создания документа закрытия: ${e.data.message}`));
  };
  return (
    <>
      {dataWcc.length == 0 ? (
        <>
          <Tooltip title="Сформировать акт">
            <IconButton size="small" onClick={() => setWccDialogOpen(true)}>
              <NoteAddOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <WccSupplierInvoiceDialog open={wccDialogOpen} onClose={() => setWccDialogOpen(false)} onSubmit={handleWccInvoice} />
        </>
      ) : (
        <WccButton invoiceId={invoiceId} invoiceType={INVOICE_TYPE_SUPPLIER} initialWcc={dataWcc[0]} />
      )}
    </>
  );
}
